import "./SkyOne.css";
import Navbar from "../component/layout/Navbar";
import ProjectHighlightCard from "../component/cards/ProjectHighlightCard";
import FloorPlanCard from "../component/cards/FloorPlanCard";
import Banner from "../component/banner/Banner";
import Intro from "../component/intro/Intro";
import ApplicationForm from "../component/forms/ApplicationForm";
import Map from "../component/map/Map";
import FAB from "../component/fab/fab";
import Footer from "../component/layout/Footer";
import bannerImg from "../asset/image/skyone/banner.jpg";
import { skyOneHighlights } from "../asset/skyone/skyOneHighlights";
import { genSphereIntro } from "../asset/gensphere/genSphereIntro";
import { genSphereUnitLayouts } from "../asset/gensphere/genSphereUnitLayouts";

function SkyOne() {
  const accentColor = "#87CEEB";
  return (
    <div className="skyone-app-root">
      <Navbar />
      <Banner
        image={bannerImg}
        title={<>SkyOne</>}
        subtitle="Your Exclusive Luxury Home Choice."
        location="Johor Bahru"
        learnMoreLink="#project-highlights-section"
        registerLink="#application-form-section"
        primaryColor={accentColor}
      />
      <ProjectHighlightCard
        title={<>Beyond Ordinary. <span className="ph-title-break">Welcome to <span className="highlight">SkyOne</span></span></>}
        titleColor="#000"
        cardColor="#fff"
        cardTitleColor="#000"
        cardDescColor="#86868b"
        accentColor={accentColor}
        highlights={skyOneHighlights}
      />
      <Intro
        paragraphs={genSphereIntro}
        accentColor={accentColor}
        highlightColor="#000"
      />
      <FloorPlanCard
        title="Unit Layouts"
        description="Thoughtfully Designed Floor Plans for Every Home"
        layouts={genSphereUnitLayouts}
        accentColor={accentColor}
        titleColor="#000"
        descColor="#86868b"
        mediaBtnHoverColor="#2A2A2DB8"
      />
      <Map
        title="Prime Location"
        description="Seamlessly Connected to Work, Life, and Leisure"
        mapSrc="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d63816.35166687337!2d103.69153074863281!3d1.4606040000000202!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da1300532f7647%3A0xfd5dd2ad828de3d0!2sGen%20Sphere%20by%20Majestic%20Gen!5e0!3m2!1sen!2smy!4v1768667541256!5m2!1sen!2smy"
        address={<>Jalan Lepas<br />Tanjung Puteri<br />80300 Johor Bahru</>}
        directionLink="https://www.google.com/maps/place/Gen+Sphere+by+Majestic+Gen/@1.460604,103.767748,12z/data=!4m6!3m5!1s0x31da1300532f7647:0xfd5dd2ad828de3d0!8m2!3d1.460604!4d103.7677484!16s%2Fg%2F11md2rwjqg?hl=en&entry=ttu&g_ep=EgoyMDI2MDExMy4wIKXMDSoKLDEwMDc5MjA2N0gBUAM%3D"
        primaryColor="#000"
        secondaryColor="#8E8E93"
        cardColor="#fff"
      />
      <ApplicationForm
        unitLayouts={genSphereUnitLayouts}
        accentColor={accentColor}
        bgColor="#fff"
        primaryColor="#000"
        secondaryColor="#8E8E93"
        tertiaryColor="#9E9EA3"
      />
      <FAB />
      <Footer textColor="#000" />
    </div>
  );
}

export default SkyOne;
